// Single source of truth for the work shown on the site.
// Imported by both the hero index and the projects section.

export const projects = [
    {
      id: "secret-sale",
      title: "Secret Sale - E-commerce Platform",
      start: "2025-08",
      end: "2025-09",
      category: "web",
      type: "Full-Stack E-commerce Solution",
      description:
        "Enterprise-grade multi-service e-commerce platform built on MedusaJS v2, featuring a customer storefront, point-of-sale system, campaign management, and comprehensive order fulfillment with multiple payment integrations.",
      benefits: [
        "Complete e-commerce solution with MedusaJS v2 backend and Next.js 15 storefront",
        "Point-of-Sale admin interface with order management and label printing",
        "Multiple payment gateway integrations (Stripe, PayFast, Manual payments)",
        "Advanced product search with Meilisearch integration",
        "Bulk product management with CSV import/export",
        "Partial fulfillment support with item-level tracking",
      ],
      technologies: [
        "Next.js 15",
        "MedusaJS v2",
        "TypeScript",
        "PostgreSQL",
        "Redis",
        "Meilisearch",
        "Docker",
        "TailwindCSS",
        "Shadcn UI",
      ],
      links: {
        website: "https://secretsale.co.za/",
      },
      images: ["/secret-sale.webp"],
      featured: true,
    },
    {
      id: "jaride",
      title: "Jaride - Multi-Service Platform",
      start: "2024-01",
      end: "2024-03",
      category: "web",
      type: "WordPress Multi-Service Platform",
      description:
        "Comprehensive multi-service platform offering taxi booking, food delivery, accommodation booking, and cargo services with integrated payment systems and mobile app availability.",
      benefits: [
        "Unified platform for multiple transportation and lifestyle services",
        "Integrated payment system with credit purchasing functionality",
        "Mobile app availability on both iOS and Android platforms",
        "Real-time booking and tracking across all services",
        "Multi-language support and localized payment methods",
      ],
      technologies: [
        "WordPress",
        "PHP",
        "JavaScript",
        "Mobile Apps",
        "Payment Integration",
        "Multi-service API",
      ],
      images: ["/85.webp"],
      featured: false,
      links: {
        website: "https://jaride.org",
        appStore: "https://apps.apple.com/us/app/ja-ride/id6478985246",
        playStore:
          "https://play.google.com/store/apps/details?id=com.xcellencetech.jaride",
      },
    },
    {
      id: "jacasa",
      title: "JaCASA - Accommodation Platform",
      start: "2024-06",
      end: "2024-11",
      category: "web",
      type: "WordPress Real Estate Platform",
      description:
        "Comprehensive accommodation and real estate platform offering property listings, agent management, and booking functionality with advanced search and filtering capabilities.",
      benefits: [
        "Advanced property search with multiple filters and amenities",
        "Integrated booking system for rentals and sales",
        "Agent and agency management with listing promotion",
        "Multi-property type support including apartments, condos, offices, and shops",
        "Location-based search across multiple cities",
      ],
      technologies: [
        "WordPress",
        "PHP",
        "JavaScript",
        "Real Estate API",
        "Booking System",
        "Geolocation",
      ],
      images: ["/82.webp"],
      featured: false,
      links: {
        website: "https://accommodation.jaride.org",
      },
    },
    {
      id: "jaride-eat",
      title: "Jaride Eat - Food Delivery Platform",
      start: "2024-04",
      end: "2024-10",
      category: "web",
      type: "WordPress Food Delivery Platform",
      description:
        "Food delivery and restaurant platform offering online ordering, takeaway services, and grocery delivery with categorized menu browsing and promotional pricing.",
      benefits: [
        "Comprehensive food ordering system with pickup and delivery options",
        "Restaurant and grocery integration with real-time inventory",
        "Category-based food browsing (BBQ, Burger, Pizza, Vegetarian, etc.)",
        "Promotional pricing system with discounted menu items",
        "Shopping cart functionality with user account management",
      ],
      technologies: [
        "WordPress",
        "PHP",
        "JavaScript",
        "Food Delivery API",
        "Payment Integration",
        "Inventory Management",
      ],
      images: ["/84.webp"],
      featured: false,
      links: {
        website: "https://eat.jaride.org",
      },
    },
    {
      id: "esorpa",
      title: "Esorpa Inc Corporate Website",
      start: "2024-03",
      end: "2024-04",
      category: "web",
      type: "React Corporate Website",
      description:
        "Modern corporate website built with React, featuring responsive design and professional presentation for business services and company information.",
      benefits: [
        "Modern, responsive design optimized for all devices",
        "Fast loading performance with React optimization",
        "Professional corporate presentation and branding",
        "SEO-optimized structure for better search visibility",
      ],
      technologies: [
        "React",
        "JavaScript",
        "CSS3",
        "Responsive Design",
        "SEO Optimization",
      ],
      images: ["/83.webp"],
      featured: false,
      links: {
        website: "https://esorpainc.com",
      },
    },
    {
      id: "rectron-summit",
      title: "Rectron Summit App",
      start: "2024-08",
      end: "2024-09",
      category: "mobile",
      type: "Event Management App",
      description:
        "Comprehensive Summit app developed within a three-week deadline, providing attendee engagement, networking, and event navigation features.",
      benefits: [
        "Enhanced attendee experience through objective-based engagement and rewards",
        "Facilitated networking with e-business card sharing functionality",
        "Improved event navigation with interactive floorplan",
        "Streamlined communication through notifications and program updates",
      ],
      technologies: [
        "React Native",
        "Firebase",
        "Node.js",
        "React Admin Panel",
      ],
      images: [
        "/11.webp", // Cover image
        "/12.webp", // Additional images
        "/13.webp",
        "/14.webp",
        "/15.webp",
        "/16.webp",
        "/17.webp",
      ],
      featured: true,
      links: {
        appStore: "https://apps.apple.com/us/app/rectron-summit/id6503193353",
        playStore:
          "https://play.google.com/store/apps/details?id=com.nexus.rrsummit",
        website: "https://rectronapp.co.za",
      },
    },
    {
      id: "comic-con-africa",
      title: "Comic Con Africa",
      start: "2023-04",
      end: "2023-09",
      category: "mobile",
      type: "Event & Gamification App",
      description:
        "Feature-rich event management app for Africa's largest pop culture convention, featuring gamification with quests and treasure hunts, real-time programme schedules, exhibitor discovery, QR code scanning, leaderboards, and integrated ticketing.",
      benefits: [
        "Gamification system with quests, treasure hunts, and competitive leaderboards",
        "Real-time programme scheduling with detailed event information and notifications",
        "Interactive exhibitor directory with detailed profiles and floorplan navigation",
        "QR code scanning for check-ins, treasure hunts, and exclusive content unlocks",
        "Integrated ticketing via Howler API with secure scan-to-enter functionality",
        "Special zones support including KidsCon, StreamerCon, and Otaku content",
      ],
      technologies: [
        "Expo",
        "React Native",
        "Firebase",
        "Strapi CMS",
        "AWS Cognito",
        "Howler API",
        "QR Scanning",
      ],
      images: [
        "/40.webp",
        "/41.webp",
        "/42.webp",
        "/43.webp",
        "/44.webp",
        "/45.webp",
        "/46.webp",
        "/47.webp",
        "/48.webp",
        "/49.webp",
        "/50.webp",
      ],
      featured: true,
      links: {
        appStore: "https://apps.apple.com/us/app/comic-con-africa/id6447425714",
        playStore:
          "https://play.google.com/store/apps/details?id=com.nexus.comicconafrica",
      },
    },
    {
      id: "equity-bank-portal",
      title: "Equity Bank Data Portal",
      start: "2021-01",
      end: "2022-01",
      category: "web",
      type: "Financial Application",
      description:
        "Web application for remote credit card application processing in Congo, enabling global access for Congolese citizens.",
      benefits: [
        "Enables global access for Congolese credit card applications",
        "Removes geographical limits and boosts financial inclusion",
        "Improved user satisfaction with multi-language support",
      ],
      technologies: [
        "Angular 7",
        "Java",
        "Spring Boot",
        "MongoDB",
        "MySQL",
        "JWT",
        "Firebase",
      ],
      images: ["/81.webp"],
      featured: false,
      links: {
        website:
          "https://www.equitybcdc-diasporabanking.com/equity-bank-ui/home",
      },
    },
    {
      id: "cricut-ambassador",
      title: "Cricut Ambassador App",
      start: "2024-10",
      end: "2025-03",
      category: "mobile",
      type: "Ambassador Management Platform",
      description:
        "Comprehensive multi-country ambassador management platform for Cricut, featuring gamification, training modules, demo scheduling, digital wallet with banking integration, and real-time leaderboards across South Africa, Middle East, Israel, and Turkey.",
      benefits: [
        "Multi-country support with region-specific wallet and payout systems for 4 markets",
        "Comprehensive gamification system with challenges, leaderboards, and tiered rewards",
        "Integrated training platform with video modules, quizzes, and certification tracking",
        "Demo scheduling with GPS verification and buddy system for event coordination",
        "Digital wallet with banking integration for commission payouts and product purchases",
        "Real-time push notifications and OTA updates via Expo for seamless user experience",
      ],
      technologies: [
        "React Native",
        "Expo",
        "Strapi CMS",
        "Firebase",
        "Sentry",
        "Multi-region APIs",
        "Push Notifications",
        "Geolocation",
      ],
      images: [
        "/70.webp", // Cover image
        "/71.webp", // Additional images
        "/72.webp",
        "/73.webp",
        "/74.webp",
        "/75.webp",
        "/76.webp",
        "/77.webp",
        "/78.webp",
      ],
      featured: false,
    },
    {
      id: "cricut-wishlist",
      title: "Cricut Wishlist Plugin",
      start: "2025-02",
      end: "2025-03",
      category: "wordpress",
      type: "WordPress Plugin",
      description:
        "Feature-rich WordPress plugin for creating and sharing personalized Cricut product wishlists with live preview, QR code generation, social media integration, and comprehensive admin analytics dashboard.",
      benefits: [
        "Interactive wishlist creator with real-time live preview using HTML5 Canvas",
        "Social media sharing with optimized Open Graph meta tags for Facebook and Twitter",
        "QR code generation for easy mobile sharing and product discovery",
        "Comprehensive admin dashboard with share tracking and wishlist analytics",
        "Multiple customizable messages and background images per campaign",
        "Responsive mobile-first design with custom branded typography",
      ],
      technologies: [
        "WordPress",
        "PHP",
        "jQuery",
        "HTML5 Canvas",
        "AJAX",
        "QRCode.js",
        "Open Graph API",
        "MySQL",
      ],
      images: ["/80.webp"],
      featured: false,
    },
    {
      id: "joj",
      title: "JOJ Mobile App",
      start: "2022-10",
      end: "2023-12",
      category: "mobile",
      type: "Festival App",
      description:
        "Mobile app for festival-goers providing up-to-date lineup and schedule information, available on both Play Store and Apple Store.",
      benefits: [
        "Detailed lineup and schedule information with real-time updates",
        "Engaging features like personalized schedules and interactive maps",
        "Enhanced user experience and satisfaction for festival attendees",
      ],
      technologies: ["React Native", "Firebase", "Node.js", "Howler API"],
      images: [
        "/51.webp", // Cover image
        "/52.webp", // Additional images
        "/53.webp",
        "/54.webp",
        "/55.webp",
        "/56.webp",
        "/57.webp",
        "/58.webp",
        "/59.webp",
        "/60.webp",
      ],
      featured: false,
      links: {
        appStore:
          "https://apps.apple.com/us/app/standard-bank-joy-of-jazz/id6467728574",
        playStore:
          "https://play.google.com/store/apps/details?id=com.ganizani.joj",
      },
    },
    {
      id: "vaya-x",
      title: "Vaya X",
      start: "2025-01",
      end: "present",
      category: "mobile",
      type: "Multi-Service Transportation Platform",
      description:
        "Enterprise-grade multi-service transportation platform built with Yarn workspaces monorepo architecture, supporting taxi booking, food delivery, accommodation, and cargo services across 20+ African countries with integrated payment systems and real-time tracking.",
      benefits: [
        "Multi-country and multi-currency support for 20+ African regions including Tanzania e-ticketing compliance",
        "Comprehensive payment integration with 15+ gateways including Stripe, PayPal, PayStack, and Flutterwave",
        "Monorepo architecture with shared business logic across mobile app, web dashboard, and cloud functions",
        "Real-time booking system with driver matching, trip tracking, and automated notifications",
        "Fleet management dashboard for admin and fleet operators with detailed analytics",
        "Wallet system with locked balance support for referral bonuses and promotional credits",
      ],
      technologies: [
        "Expo",
        "React Native",
        "React",
        "Firebase",
        "Cloud Functions",
        "Redux Toolkit",
        "Multi-payment APIs",
        "Google Maps",
      ],
      images: [
        "/20.webp", // Cover image
        "/21.webp", // Additional images
        "/22.webp",
        "/23.webp",
        "/24.webp",
        "/25.webp",
        "/26.webp",
        "/27.webp",
        "/28.webp",
        "/29.webp",
        "/30.webp",
        "/31.webp",
        "/19.webp",
      ],
      featured: false,
      links: {
        website: "https://vayax-78d77.web.app/",
      },
    },
    {
      id: "poster-builder",
      title: "AmissihArt - Poster Builder",
      start: "2025-08",
      end: "2025-12",
      category: "web",
      type: "SaaS Design Platform",
      description:
        "Professional-grade poster and design creation platform with AI-powered template generation, advanced design tools, and seamless collaboration features for creating stunning posters, flyers, and social media graphics.",
      benefits: [
        "AI-powered smart template generation from text prompts using OpenAI",
        "Professional drag-and-drop editor with Fabric.js canvas",
        "Advanced data visualization with 5 chart types (Bar, Line, Pie, Donut, Area)",
        "500+ professional templates across business, marketing, education, and events",
        "Multi-format export (PNG, JPG, PDF, SVG) with quality options up to 2x resolution",
        "Tiered subscription system with Free, Pro, and Business plans",
      ],
      technologies: [
        "React",
        "Firebase",
        "Material-UI",
        "Fabric.js",
        "OpenAI API",
        "Google Fonts API",
        "Cloud Functions",
      ],
      images: ["/poster-builder.webp"],
      featured: false,
      links: {
        github: "https://github.com/htusse/poster-builder-ui",
      },
    },
    // {
    //   title: "EventApp - Event Management Platform",
    //   period: "December 2025 - Present",
    //   category: "web",
    //   type: "React Event Management PWA",
    //   status: "In Progress",
    //   description:
    //     "Comprehensive event management platform enabling users to create, manage, and sell tickets for events with integrated PayFast payment processing, QR-coded tickets, and real-time order management.",
    //   benefits: [
    //     "Complete event creation and management with draft saving at every step",
    //     "PayFast payment integration with secure webhook handling and signature verification",
    //     "Automated QR-coded ticket generation upon successful payment",
    //     "4-day free trial system for new users",
    //     "Order management with automatic cleanup of abandoned orders",
    //     "Mobile-first responsive design with PWA capabilities",
    //   ],
    //   technologies: [
    //     "React 19",
    //     "TypeScript",
    //     "Vite",
    //     "Tailwind CSS 4",
    //     "Firebase",
    //     "PayFast API",
    //     "Cloud Functions",
    //   ],
    //   images: ["/eventapp.webp"],
    //   featured: false,
    // },
    // {
    //   title: "TruFit Lifestyle - Health & Wellness PWA",
    //   period: "2025 - Present",
    //   category: "web",
    //   type: "Progressive Web Application",
    //   status: "In Progress",
    //   description:
    //     "Mobile-first Progressive Web Application for health and wellness management featuring client onboarding, referral tracking, subscription management, e-commerce health shop, and community features.",
    //   benefits: [
    //     "Client database supporting 5,000+ users with unique WhatsApp referral links",
    //     "Three-tier subscription system (Free, Monthly/Quarterly, One-Time Programs)",
    //     "Integrated e-commerce health shop with member discounts",
    //     "Live webinar platform with Zoom/Google Meet integration",
    //     "Real-time community chat with group rooms and private messaging",
    //     "PayFast payment integration for South African market",
    //   ],
    //   technologies: [
    //     "React 19",
    //     "TypeScript",
    //     "Vite",
    //     "Tailwind CSS 4",
    //     "Firebase",
    //     "Zustand",
    //     "TanStack Query",
    //     "PayFast",
    //   ],
    //   images: ["/trufit.webp"],
    //   featured: false,
    // },
    {
      id: "whatsapp-bot",
      title: "WhatsApp Business Bot",
      start: "2025-12",
      end: "2026-01",
      category: "web",
      type: "Node.js Bot Application",
      description:
        "Automated WhatsApp bot using Meta's WhatsApp Business Platform API for business communication, featuring webhook integration, automated responses, and interactive messaging capabilities.",
      benefits: [
        "Automated customer response system with customizable commands",
        "Webhook integration for real-time message processing",
        "Interactive button and media message support",
        "Easy deployment with ngrok for local development",
        "Scalable architecture for business communication needs",
        "Comprehensive command system (greeting, help, info, contact)",
      ],
      technologies: [
        "Node.js",
        "Express",
        "Meta WhatsApp API",
        "Webhooks",
        "ngrok",
      ],
      images: ["/whatsapp-bot.webp"],
      featured: false,
      links: {
        github: "https://github.com/htusse/whatsappbot",
      },
    },
    {
      id: "strapi-excel-exporter",
      title: "Strapi Excel Exporter Plugin",
      start: "2024",
      end: "2024",
      category: "strapi",
      type: "Strapi CMS Plugin",
      description:
        "Custom Strapi plugin enabling administrators to export collection data to Excel spreadsheets with configurable columns, filters, and formatting options for streamlined data analysis and reporting.",
      benefits: [
        "One-click Excel export from any Strapi collection with custom column selection",
        "Support for filtered data exports based on current view settings",
        "Configurable column formatting and data transformation",
        "Seamless integration with Strapi admin panel UI",
        "Bulk data export for reporting and analytics workflows",
      ],
      technologies: [
        "Strapi",
        "Node.js",
        "xlsx",
        "React",
        "Strapi Plugin API",
      ],
      images: ["/strapi-excel-exporter.webp"],
      featured: false,
    },
    {
      id: "strapi-ambassador-dashboard",
      title: "Ambassador Overview Dashboard Plugin",
      start: "2024",
      end: "2024",
      category: "strapi",
      type: "Strapi CMS Plugin",
      description:
        "Custom Strapi admin plugin providing a comprehensive dashboard for ambassador program management with real-time analytics, performance metrics, and activity tracking across multiple regions.",
      benefits: [
        "Real-time ambassador performance metrics and KPI visualization",
        "Multi-region overview with country-specific filtering",
        "Activity tracking for demos, training completions, and engagements",
        "Leaderboard integration with point-based ranking system",
        "Quick access to ambassador profiles and management actions",
      ],
      technologies: [
        "Strapi",
        "Node.js",
        "React",
        "Chart.js",
        "Strapi Plugin API",
      ],
      images: ["/strapi-ambassador-dashboard.webp"],
      featured: false,
    },
    {
      id: "strapi-email-plugin",
      title: "Custom Email Plugin",
      start: "2024",
      end: "2024",
      category: "strapi",
      type: "Strapi CMS Plugin",
      description:
        "Custom Strapi plugin extending email functionality with template management, bulk email capabilities, and SendGrid integration for ambassador communications and automated notifications.",
      benefits: [
        "Custom email template management with dynamic variable support",
        "Bulk email sending to filtered user groups (ambassadors, trainees, trainers)",
        "SendGrid integration with delivery tracking and analytics",
        "Scheduled email campaigns with cron-based automation",
        "Role-based email targeting for targeted communications",
      ],
      technologies: [
        "Strapi",
        "Node.js",
        "SendGrid API",
        "React",
        "Strapi Plugin API",
      ],
      images: ["/strapi-email-plugin.webp"],
      featured: false,
    },
];

export const categories = [
    { key: "all", labelKey: "category.all" },
    { key: "mobile", labelKey: "category.mobile" },
    { key: "web", labelKey: "category.web" },
    { key: "wordpress", labelKey: "category.wordpress" },
    { key: "strapi", labelKey: "category.strapi" }
];

// Each kind of work gets its own hue, so the site can be scanned by colour.
// Consumed by the projects grid, the filter bar and the hero index.
export const categoryTone = {
  web: "green",
  mobile: "blue",
  wordpress: "amber",
  strapi: "plum",
};

export const toneStyle = (category) => {
  const tone = categoryTone[category];
  if (!tone) return undefined;
  return {
    "--tone": `var(--c-${tone})`,
    "--tone-tint": `var(--c-${tone}-tint)`,
  };
};

// --- Sorting -------------------------------------------------------------
// Projects carry structured dates — "YYYY-MM", "YYYY", or "present" — so that
// ordering never depends on parsing prose, and so the same records can be read
// in any language. Display formatting lives in src/i18n/format.js.

// Months since year 0, so periods compare as plain numbers. Ongoing work sorts
// above everything finished.
export const periodEnd = (project = {}) => {
  const value = project.end;
  if (value === "present") return Number.MAX_SAFE_INTEGER;
  if (typeof value !== "string") return 0;

  const match = /^(\d{4})(?:-(\d{2}))?$/.exec(value);
  if (!match) return 0;

  // A bare year means "some time that year" — treat it as December so it does
  // not sort below January of the same year.
  const month = match[2] ? Number(match[2]) - 1 : 11;
  return Number(match[1]) * 12 + month;
};

// --- Filtering -----------------------------------------------------------

/**
 * Technology names are written differently in different places — "React.js" in
 * the skills list, "React" on a project, "Next.js 15" and "Angular 7" carrying
 * versions. Strip the decoration so those line up.
 *
 * Matching is on the normalised name in full, deliberately not on substrings:
 * "React Native" contains "React", so a substring rule would return React web
 * apps when the reader asked for React Native ones.
 */
export const normalizeTech = (value = "") =>
  value
    .toLowerCase()
    .replace(/\.js\b/g, "")
    .replace(/\bv?\d+(\.\d+)*\b/g, "")
    .replace(/[^a-z0-9+#/ ]/g, " ")
    .replace(/\s+/g, " ")
    .trim();

export const projectMatchesTech = (project, tech) => {
  const needle = normalizeTech(tech);
  return project.technologies.some((t) => normalizeTech(t) === needle);
};

// The English original is searched alongside the translation. Someone typing
// "medusa" or "e-commerce" is reaching for a word that was never translated,
// and it would be a poor experience for that to stop working in French.
const ENGLISH_BY_ID = new Map(projects.map((project) => [project.id, project]));

const searchCorpus = (project) => {
  const english = ENGLISH_BY_ID.get(project.id);
  const parts = [project.title, project.type, project.description, ...project.technologies];

  // `english !== project` is an identity check, not a value comparison: when
  // the caller passes the untranslated English array itself, `english` *is*
  // that same object, so the English fields are skipped rather than doubled
  // up in the corpus. When the caller passes merged translated objects, the
  // spread in the caller always produces a new object, so the identity check
  // is false and the English text is appended for fallback search.
  if (english && english !== project) {
    parts.push(english.title, english.type, english.description);
  }

  return parts.join(" ").toLowerCase();
};

/**
 * The one place filtering happens. Category, stack and text narrow the list
 * together — each is an AND — and selecting several technologies requires all
 * of them, which is what "React *and* Firebase" is normally taken to mean.
 *
 * `list` is the projects as the reader sees them, which in a translated
 * language is not the English array this module exports. It defaults to that
 * array so English callers and tests need not pass anything.
 */
export const selectProjects = (
  { query = "", category = "all", techs = [], sort = "recent" } = {},
  list = projects,
  locale = "en"
) => {
  const hasFilters = query.trim() !== "" || category !== "all" || techs.length > 0;
  const needle = query.trim().toLowerCase();

  const result = list.filter((project) => {
    // With nothing selected the grid is the catalogue of everything that isn't
    // already on display in the featured spread above it.
    if (!hasFilters && project.featured) return false;
    if (category !== "all" && project.category !== category) return false;
    if (!techs.every((tech) => projectMatchesTech(project, tech))) return false;
    if (needle && !searchCorpus(project).includes(needle)) return false;
    return true;
  });

  const sorted = [...result];
  if (sort === "az") {
    sorted.sort((a, b) => a.title.localeCompare(b.title, locale));
  } else if (sort === "oldest") {
    sorted.sort((a, b) => periodEnd(a) - periodEnd(b));
  } else {
    sorted.sort((a, b) => periodEnd(b) - periodEnd(a));
  }

  return sorted;
};

// Every technology that appears on at least one project, with its count,
// most-used first — the source for the stack picker.
export const techIndex = () => {
  const counts = new Map();
  projects.forEach((project) => {
    project.technologies.forEach((tech) => {
      counts.set(tech, (counts.get(tech) || 0) + 1);
    });
  });
  return [...counts.entries()]
    .map(([name, count]) => ({ name, count }))
    .sort((a, b) => b.count - a.count || a.name.localeCompare(b.name));
};

// The same technology is spelled differently in different places ("React.js"
// in the skills list, "React" on a project). Filters store the project's own
// spelling, so a chip clicked in the skills section and the matching row in the
// stack picker refer to the same thing and both read as selected.
const CANONICAL = new Map();
projects.forEach((project) => {
  project.technologies.forEach((tech) => {
    const key = normalizeTech(tech);
    if (!CANONICAL.has(key)) CANONICAL.set(key, tech);
  });
});

export const canonicalTech = (name) => CANONICAL.get(normalizeTech(name)) || name;
